import NavigableValidation from "../models/navigableValidations/navigableValidation";
import {INavigableValidatableModel} from "../interfaces/navigableValidationInterfaces";
import {Constructor} from "../../global/constructor";
import ValidationError, {ValidationErrorLevel} from "~/models/validationError";
import ValidationErrorCollection from "~/models/navigableValidations/validationErrorCollection";

export default function Validatable<T extends INavigableValidatableModel<T>, TValidation extends NavigableValidation<T>, TBase extends Constructor>(Base: TBase) {
  return class extends Base {
    _validation: TValidation;

    get validationResults(): ValidationErrorCollection {
      return this.validation.results;
    }

    get errorCount(): number {
      return this.validation.errors.length;
    }

    errorsForField(field: string): Array<ValidationError> {
      return this.validation.errors.filter(e => e.field === field)
    }

    errorsForLevel(level: ValidationErrorLevel = ValidationErrorLevel.All): Array<ValidationError> {
      return this.validation.results.getErrors(level)
    }

    errorLevelCount(level: ValidationErrorLevel = ValidationErrorLevel.All): number{
      return this.errorsForLevel(level).length
    }

    get isValid(): boolean {
      return this.validation.isValid;
    }

    get isInvalid(): boolean {
      return !this.isValid
    }

    validate(): boolean {
      return this.isValid;
    }

    get validation(): TValidation {
      return this._validation;
    }

    create<TOther>(c: new() => TOther): TOther {
      return new c();
    }
  };
}